import { render } from "./AddNewPatientOverlay.vue?vue&type=template&id=1dbdb1a3&scoped=true&lang=pug"
import script from "./AddNewPatientOverlay.vue?vue&type=script&lang=js"
export * from "./AddNewPatientOverlay.vue?vue&type=script&lang=js"

import "./AddNewPatientOverlay.vue?vue&type=style&index=0&id=1dbdb1a3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbdb1a3"]])

export default __exports__